export default "__VITE_ASSET__BjoiIlf$__"